import { useEffect, useState } from 'react';

import { emitWidgetReady } from 'services/eventBus/narrativeWidgetsEventBus';

import {
    MAX_WAIT_MS,
    TIMEOUT_MESSAGE,
} from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/hooks/useNarrative';
import { IComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { UseAutomatedNarrativeProvider } from 'components/widgets/automatedNarrative/AutomatedNarrative.provider';

interface Props {
    widgetId: IComponentProps['widgetId'];
    ui: UseAutomatedNarrativeProvider['ui'];
}

export const useAutomatedNarrativeLogic = ({ ui, widgetId }: Props) => {
    const [isLoadingNarrative, setIsLoadingNarrative] = useState(true);

    useEffect(() => {
        // auto-close timer (3 minutes)
        const timeout = setTimeout(() => {
            setIsLoadingNarrative(false);
            ui.setters.setNarrative(TIMEOUT_MESSAGE);
            //Notify that the widget is ready - to enable export even if no data
            if (widgetId !== undefined) {
                emitWidgetReady(widgetId);
            }
        }, MAX_WAIT_MS);

        // if narrative arrived before timeout
        if (ui.vars.narrative) {
            clearTimeout(timeout);
            setIsLoadingNarrative(false);
        }

        return () => clearTimeout(timeout);
    }, [ui.vars.narrative]);

    return {
        logic: {
            isLoadingNarrative,
        },
    };
};
